export default __webpack_public_path__ + "static/media/Avatar.6646b500.jpg";